import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import menus from '../menu';
import StatsEliteLogo from '../../brand/StatsEliteLogo';

function Header(props) {
    const location = useLocation();
    return (
        <div id="header" className="header bg-color">
            <div className="container">
                <div className="row">
                    <div className="header-wrap">
                        <div className="col-md-2">
                            <div id="logo" className="logo">
                                <Link to="/">
                                    <StatsEliteLogo markSize={44} wordSize={16} gap={8} />
                                </Link>
                            </div>
                            {/* logo*/}
                        </div>
                        {/* .col-md-2  */}
                        <div className="col-md-10">
                            <div className="flat-show-search">
                                <div className="show-search">
                                    <Link to="#"><i className="fa fa-search"></i></Link>
                                </div>
                                <div className="top-search">
                                    <form action="#" id="searchform-all" method="get">
                                        <div>
                                            <input type="text" id="s" className="sss" placeholder="Search..." />
                                            <input type="submit" value="" id="searchsubmit" />
                                        </div>
                                    </form>
                                </div>
                                {/* <!-- /.top-search --> */}
                            </div>
                            {/* <!-- /.flat-show-search -->*/}
                            <div className="nav-wrap">
                                <div className="btn-menu">
                                    <span></span>
                                </div>
                                {/* <!-- //mobile menu button -->*/}
                                <nav id="mainnav" className="mainnav">
                                    <ul className="menu">
                                        {
                                            menus.map(data =>(
                                                <li className={data.name === props.data.names || location.pathname === data.linkmenu ? "active" : ""} key={data.id}>
                                                    <Link to={data.linkmenu}
                                                   style={{
                                                       color: location.pathname === data.linkmenu ? '#62B6E8' : '#ffffff',
                                                       borderBottom: location.pathname === data.linkmenu ? '2px solid #62B6E8' : 'none',
                                                       paddingBottom: '2px',
                                                       transition: 'color 0.3s ease, border-bottom 0.3s ease'
                                                   }}
                                                   onMouseOver={(e) => {
                                                       if (location.pathname !== data.linkmenu) {
                                                           e.target.style.color = '#ffffff';
                                                       }
                                                   }}
                                                   onMouseOut={(e) => {
                                                       if (location.pathname !== data.linkmenu) {
                                                           e.target.style.color = '#ffffff';
                                                       }
                                                   }}>
                                                    {data.name}
                                                </Link>
                                                    </li>
                                            ))
                                        }
                                    </ul>
                                    {/* <!-- /.menu -->*/}
                                </nav>
                                {/* <!-- /#mainnav -->*/}
                            </div>
                            {/* <!-- /.nav-wrap --> */}
                        </div>
                        {/* <!-- /.col-md-9 --> */}
                    </div>
                    {/* <!-- /.header-wrap --> */}
                </div>
                {/* <!-- /.row --> */}
            </div>
            {/* <!-- /.container --> */}
        </div>
    );
}

export default Header;
